import { MessageGroupSystemEvent } from "../messageGroups.types";

const listNames = (members: { name?: string }[] | undefined) => {
  const names = (members ?? []).map((member) => member.name?.trim()).filter(Boolean) as string[];
  if (names.length === 0) return "someone";
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]} and ${names[1]}`;
  return `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
};

export const getSystemEventText = (message: any, actorName: string): string => {
  const event = message?.systemEvent as MessageGroupSystemEvent | undefined;
  const payload = message?.systemPayload ?? {};

  switch (event) {
    case "groupCreated":
      return `${actorName} created "${payload.groupName ?? "the group"}" with ${listNames(payload.members)}`;
    case "membersAdded":
      return `${actorName} added ${listNames(payload.members)}`;
    case "memberRemoved":
      return `${actorName} removed ${payload.member?.name ?? "a member"}`;
    case "memberLeft":
      return `${payload.member?.name ?? actorName} left the group`;
    case "renamed":
      return `${actorName} renamed the group to "${payload.groupName ?? ""}"`;
    case "avatarChanged":
      return `${actorName} changed the group photo`;
    default:
      return `${actorName} updated the group`;
  }
};
